<span class="step-container">
  @for (step of stepList; track $index; let i = $index) {
    <div>
      <span class="step">
        <div
          [ngClass]="{
            active: currentStep === i + 1,
            completed: i + 1 < currentStep,
            inactive: i + 1 > currentStep
          }"
        >
          @if (i + 1 >= currentStep) {
            <p>{{ i + 1 }}</p>
          }
          @if (i + 1 < currentStep) {
            <i class="pi pi-check icon-stepper"></i>
          }
        </div>
        <div class="label-container">
          {{ step | translate }}
        </div>
      </span>
      @if (i < stepList.length - 1) {
        <span>
          <hr [ngClass]="{ 'inactive-line': i + 2 > currentStep }" />
        </span>
      }
    </div>
  }
</span>
